module.exports = "<div style=\"text-align: center\">\n  <h1>404 – Not Found</h1>\n  <p>\n    We could not find a page in this URI.<br>\n    Try the <a href=\"/\">home page</a> instead?\n  </p>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./404.html
 ** module id = 272
 ** module chunks = 0
 **/